import {useEffect, useState} from "react"
import {Radio} from "antd"
import {useTranslation} from "react-i18next"
import {BasePopup} from "components/popup"
import {BaseButton} from "components/buttons"
import {FormLabel} from "components/Form"
import {userProfileServiceV3} from "services"
import {handleError, toastSuccess} from "helpers"
import styles from "./PopupSpecialEvent.module.css"

type Props = {
    isShow: boolean
    studentProfileIds: number[]
    onClose: () => void
    onSuccess: () => void
}

export function PopupSpecialEvent(props: Props) {
    const {isShow, studentProfileIds, onClose, onSuccess} = props
    const {t} = useTranslation(["common"])
    const [specialEventEnabled, setSpecialEventEnabled] = useState(true)
    const [isSubmitting, setIsSubmitting] = useState(false)

    useEffect(() => {
        if (isShow) {
            setSpecialEventEnabled(true)
        }
    }, [isShow])

    const handleClose = () => {
        setSpecialEventEnabled(true)
        onClose()
    }

    const onSubmit = async () => {
        if (!studentProfileIds.length) {
            return
        }
        try {
            setIsSubmitting(true)
            await userProfileServiceV3.update(
                studentProfileIds.map((profileId) => ({
                    id: profileId,
                    isSpecialEventEnabled: specialEventEnabled
                }))
            )
            toastSuccess(
                specialEventEnabled
                    ? "Special Event enabled for selected students"
                    : "Special Event disabled for selected students"
            )
            onSuccess()
        } catch (error) {
            handleError(error)
        } finally {
            setIsSubmitting(false)
        }
    }

    return (
        <BasePopup isShow={isShow} onClose={handleClose} leftIcon="EDIT_LINE" leftIconColor="#fff" width="40vw">
            <div>
                <p className={styles.title}>{t("statsFilter.specialEvent")}</p>
                <p className={styles.description}>
                    Update Special Event for {studentProfileIds.length} selected student
                    {studentProfileIds.length === 1 ? "" : "s"}
                </p>
                <div className={styles.field}>
                    <FormLabel label={t("statsFilter.specialEvent")} />
                    <Radio.Group
                        value={specialEventEnabled}
                        onChange={(event) => setSpecialEventEnabled(event.target.value)}
                        options={[
                            {label: t("action.yes"), value: true},
                            {label: t("action.no"), value: false}
                        ]}
                    />
                </div>
                <div className={styles.action}>
                    <BaseButton title={t("action.cancel")} variant="secondary" onClick={handleClose} />
                    <BaseButton title={t("action.save")} loading={isSubmitting} onClick={onSubmit} />
                </div>
            </div>
        </BasePopup>
    )
}
